"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.configurationApi = void 0;
var _request = _interopRequireDefault(require("@/utils/request"));
var configurationApi = exports.configurationApi = {
  findAll: function findAll() {
    return (0, _request.default)({
      url: "/configuration"
    });
  },
  findParam: function findParam(params) {
    return (0, _request.default)({
      url: "/configuration/param",
      params: params
    });
  },
  create: function create(data) {
    return (0, _request.default)({
      url: "/configuration",
      method: 'post',
      data: data
    });
  },
  update: function update(id, data) {
    return (0, _request.default)({
      url: "/configuration/".concat(id, "/update"),
      method: 'post',
      data: data
    });
  }
};